import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'tca-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input() stepSize = 10;
  @Input() delta = 2;
  @Input() firstText = 'First';
  @Input() lastText = 'Last';
  @Input() showStatus = false;
  @Input() statusShowingText = 'Showing';
  @Input() statusOfText = 'of';
  @Output() pageChange = new EventEmitter<number>();

  private pageValue = 1;
  private collectionSizeValue = 0;

  @Input() set collectionSize(value: number) {
    if (value < 0) {
      this.collectionSizeValue = 0;
    } else if (value >= 999999) {
      this.collectionSizeValue = 999999;
    } else {
      this.collectionSizeValue = value;
    }
  }

  get collectionSize() {
    return this.collectionSizeValue;
  }

  @Input() get page() {
    return this.pageValue;
  }

  set page(value: number) {
    this.pageValue = value;
    this.pageChange.emit(this.pageValue);
  }

  get totalPages() {
    return Math.ceil(this.collectionSize / this.stepSize);
  }

  get pageArray() {
    if (this.collectionSize === 0) {
      return [0];
    }

    const availablePages = Array(this.totalPages).fill(0).map((x, i) => i + 1);
    const viewablePages = [];
    const currentPageIndex = this.page - 1;

    const lowerLimit = currentPageIndex - this.delta < 0 ? 0 : currentPageIndex - this.delta;
    const upperLimit = currentPageIndex + this.delta + 1 > this.totalPages ? this.totalPages : currentPageIndex + this.delta + 1;

    for (let i = lowerLimit; i < upperLimit; i++) {
      viewablePages.push(availablePages[i]);
    }

    if (viewablePages[0] !== 1) {
      if (lowerLimit - 1 !== 0) {
        viewablePages.unshift(0);
      }
      viewablePages.unshift(1);
    }

    if (viewablePages[viewablePages.length - 1] !== this.totalPages) {
      if (upperLimit + 1 !== this.totalPages) {
        viewablePages.push(0);
      }
      viewablePages.push(this.totalPages);
    }

    return viewablePages;
  }

  get currentPageLowerLimit() {
    if (this.isFirstPage(this.page) && this.collectionSize !== 0) {
      return 1;
    }

    if (!this.isFirstPage(this.page) && this.collectionSize !== 0) {
      return (this.page - 1) * this.stepSize + 1;
    }

    return 0;
  }

  get currentPageUpperLimit() {
    if (this.isFirstPage(this.page)) {

      if (this.stepSize > this.collectionSize) {
        return this.collectionSize;
      }

      return this.page + this.stepSize - 1;
    }

    if (!this.isFirstPage(this.page) && !this.isLastPage(this.page)) {
      return (this.page) * this.stepSize;
    }

    if (this.isLastPage(this.page)) {
      return this.collectionSize;
    }
  }

  constructor() { }

  ngOnInit() {
  }

  isActive(page: number) {
    return this.page === page;
  }

  isFirstPage(page: number) {
    return page === 1;
  }

  isLastPage(page: number) {
    return page === this.totalPages;
  }

  onClickFirst() {
    this.page = 1;
  }

  onClickLast() {
    this.page = this.totalPages;
  }

  onClickNext() {
    if (!this.isLastPage(this.page)) {
      this.page++;
    }
  }

  onClickPrevious() {
    if (!this.isFirstPage(this.page)) {
      this.page--;
    }
  }

  onClickPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.page = page;
    }
  }

}
